(() => {
  const tools = document.querySelectorAll("[data-dw-protection-finder]");

  const recommendations = {
    display: {
      product: "Magnetkartenhalter 35PT",
      copy:
        "Für einzelne Lieblingskarten und wertvolle Hits: stabiler Display-Schutz mit klarer Front und sauberem Sammler-Look.",
      href: "/products/magnetischer-kartenhalter-35pt-transparente-premium-kartenhulle-mit-uv-schutz-fur-sammel-trading-cards",
    },
    grading: {
      product: "Toploader + Sleeves Set",
      copy:
        "Für Versand, Sortierung und Grading-Vorbereitung: erst Sleeve, dann Toploader. Das schützt Kanten und Oberfläche.",
      href: "/products/toploader-sleeves-set-3x4-fur-tcg-sammelkarten",
    },
    binder: {
      product: "Toploader Binder",
      copy:
        "Für strukturierte Sammlungen: Karten bleiben im Toploader und sind trotzdem schnell durchblätterbar.",
      href: "/products/toploader-binder-schwarz-sammelkarten-ordner-fur-112-toploader-14-seiten-kartenmappe-mit-reissverschluss",
    },
    wall: {
      product: "WächterWall",
      copy:
        "Für Sammlerzimmer und Setup-Wände: Karten sichtbar präsentieren, ohne jedes Mal die Hülle anzufassen.",
      href: "/products/deckwachter-wachterwall™-magnetische-snap-case-wandhalterung-fur-tcg-sammelkarten-kein-bohren-flexibel-erweiterbar",
    },
  };

  const tcgNotes = {
    pokemon: "Pokémon Karten liegen meist im Standard-TCG-Format. 66x91 mm Sleeve + 3x4 Toploader ist der saubere Basisaufbau.",
    onepiece: "One Piece Karten liegen meist im Standard-TCG-Format. Für Manga Rares, Leader und Parallel Arts: erst Sleeve, dann Toploader oder Magnetkartenhalter.",
    magic: "Magic Karten liegen im Standard-TCG-Format. Für Foils und Commander-Singles: Sleeve, Toploader und bei Display-Karten Magnetkartenhalter.",
    dragonball: "Dragon Ball Super / Fusion World Karten liegen meist im Standard-TCG-Format. Für SCRs und Alt Arts direkt Sleeve + Toploader einplanen.",
    lorcana: "Lorcana Karten liegen meist im Standard-TCG-Format. Enchanted und Legendaries sollten nach dem Pull direkt gesleevt werden.",
    digimon: "Digimon Karten liegen meist im Standard-TCG-Format. Alt Arts, Secret Rares und Promos passen in den Standard-Schutzaufbau.",
    fleshblood: "Flesh and Blood Karten liegen meist im Standard-TCG-Format. Cold Foils und Promos profitieren von Sleeve + Toploader oder Magnetkartenhalter.",
    riftbound: "Riftbound Karten liegen im Standard-TCG-Umfeld. Für neue Pulls und Promos ist Sleeve + Toploader die sichere Grundlösung.",
    starwars: "Star Wars Unlimited Karten liegen meist im Standard-TCG-Format. Showcase, Hyperspace und Foils direkt geschützt sortieren.",
    yugioh: "Yu-Gi-Oh! Karten sind kleiner. Toploader können als Außenschutz passen; für Deck-Sleeves ist Small/Japanese Size sinnvoll.",
    sports: "Sportkarten können je nach Dicke variieren. Für normale Karten passen oft Sleeve + Toploader; dickere Relic- oder Patch-Karten brauchen PT-genaue Halter.",
  };

  function updateTool(tool) {
    const goal = tool.querySelector("[data-choice='goal'].is-active")?.dataset.value || "grading";
    const tcg = tool.querySelector("[data-choice='tcg'].is-active")?.dataset.value || "pokemon";
    const result = recommendations[goal] || recommendations.grading;
    tool.querySelector("[data-result-product]").textContent = result.product;
    const note = tcgNotes[tcg] || tcgNotes.pokemon;
    tool.querySelector("[data-result-copy]").textContent = `${result.copy} ${note}`;
    tool.querySelector("[data-result-link]").setAttribute("href", result.href);
  }

  tools.forEach((tool) => {
    tool.addEventListener("click", (event) => {
      const option = event.target.closest("[data-choice]");
      if (!option) return;
      const group = option.dataset.choice;
      tool.querySelectorAll(`[data-choice='${group}']`).forEach((button) => {
        button.classList.toggle("is-active", button === option);
      });
      updateTool(tool);
    });
    updateTool(tool);
  });

  document.querySelectorAll("[data-dw-filter-input]").forEach((input) => {
    const root = input.closest("[data-dw-filter-root]");
    if (!root) return;
    input.addEventListener("input", () => {
      const query = input.value.trim().toLowerCase();
      root.querySelectorAll("[data-dw-filter-item]").forEach((item) => {
        item.hidden = query && !item.textContent.toLowerCase().includes(query);
      });
    });
  });

  function padDexNumber(value) {
    return String(Number.parseInt(value, 10)).padStart(4, "0");
  }

  const generationPages = [
    { generation: 1, href: "/blogs/pokemon-lexikon/generation-1" },
    { generation: 2, href: "/blogs/pokemon-lexikon/generation-2" },
    { generation: 3, href: "/blogs/pokemon-lexikon/generation-3" },
    { generation: 4, href: "/blogs/pokemon-lexikon/generation-4" },
    { generation: 5, href: "/blogs/pokemon-lexikon/generation-5" },
    { generation: 6, href: "/blogs/pokemon-lexikon/generation-6" },
    { generation: 7, href: "/blogs/pokemon-lexikon/generation-7" },
    { generation: 8, href: "/blogs/pokemon-lexikon/generation-8" },
    { generation: 9, href: "/blogs/pokemon-lexikon/generation-9" },
  ];

  const fallbackPokemon = [
    { number: 1, name: "Bisasam", english: "Bulbasaur", types: "Pflanze · Gift", generation: 1 },
    { number: 4, name: "Glumanda", english: "Charmander", types: "Feuer", generation: 1 },
    { number: 6, name: "Glurak", english: "Charizard", types: "Feuer · Flug", generation: 1 },
    { number: 7, name: "Schiggy", english: "Squirtle", types: "Wasser", generation: 1 },
    { number: 25, name: "Pikachu", english: "Pikachu", types: "Elektro", generation: 1 },
    { number: 133, name: "Evoli", english: "Eevee", types: "Normal", generation: 1 },
    { number: 150, name: "Mewtu", english: "Mewtwo", types: "Psycho", generation: 1 },
    { number: 151, name: "Mew", english: "Mew", types: "Psycho", generation: 1 },
    { number: 249, name: "Lugia", english: "Lugia", types: "Psycho · Flug", generation: 2 },
    { number: 384, name: "Rayquaza", english: "Rayquaza", types: "Drache · Flug", generation: 3 },
    { number: 448, name: "Lucario", english: "Lucario", types: "Kampf · Stahl", generation: 4 },
    { number: 658, name: "Quajutsu", english: "Greninja", types: "Wasser · Unlicht", generation: 6 },
  ].map((pokemon) => {
    const page = generationPages.find((item) => item.generation === pokemon.generation);
    return {
      ...pokemon,
      href: `${page?.href || "/blogs/pokemon-lexikon"}#pokemon-${padDexNumber(pokemon.number)}`,
    };
  });

  function normalize(value) {
    return (value || "")
      .toString()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/ß/g, "ss")
      .replace(/[^a-z0-9]+/gi, "")
      .toLowerCase();
  }

  function levenshtein(a, b) {
    if (a === b) return 0;
    if (!a.length) return b.length;
    if (!b.length) return a.length;
    const row = Array.from({ length: b.length + 1 }, (_, index) => index);
    for (let i = 1; i <= a.length; i += 1) {
      let previous = i - 1;
      row[0] = i;
      for (let j = 1; j <= b.length; j += 1) {
        const tmp = row[j];
        row[j] = Math.min(
          row[j] + 1,
          row[j - 1] + 1,
          previous + (a[i - 1] === b[j - 1] ? 0 : 1),
        );
        previous = tmp;
      }
    }
    return row[b.length];
  }

  function scorePokemon(pokemon, query) {
    const q = normalize(query);
    if (q.length < 2) return null;
    const names = [pokemon.name, pokemon.english, ...(pokemon.aliases || [])].map(normalize).filter(Boolean);
    let best = null;
    names.forEach((name) => {
      let score = null;
      if (name === q) score = 0;
      else if (name.startsWith(q)) score = 1;
      else if (name.includes(q)) score = 2;
      else if (q.length >= 4) {
        const distance = levenshtein(name, q);
        if (distance <= (q.length <= 5 ? 1 : 2)) score = 3 + distance;
      }
      if (score !== null && (best === null || score < best)) best = score;
    });
    return best;
  }

  function escapeHtml(value) {
    return (value || "")
      .toString()
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function cardmarketSearchUrl(card) {
    const query = [card.name, card.set?.name, card.number].filter(Boolean).join(" ");
    return `https://www.cardmarket.com/de/Pokemon/Products/Search?searchString=${encodeURIComponent(query)}`;
  }

  function cardPrice(card) {
    const prices = card.cardmarket?.prices || {};
    const value = prices.trendPrice || prices.averageSellPrice || prices.lowPrice || prices.lowPriceExPlus;
    return value ? `${Number(value).toFixed(2).replace(".", ",")} EUR` : "Preis offen";
  }

  function cardmarketUrl(card) {
    return card.cardmarket?.url || "";
  }

  async function fetchPokemonCards(dexNumber) {
    const cacheKey = `dwTcgCards:v3:${dexNumber}`;
    try {
      const cached = window.sessionStorage?.getItem(cacheKey);
      if (cached) return JSON.parse(cached);
    } catch {
      // Non-critical cache read failure.
    }

    const query = `nationalPokedexNumbers:${dexNumber}`;
    const pageSize = 250;
    const select = "id,name,supertype,nationalPokedexNumbers,set,number,rarity,images,cardmarket";
    let page = 1;
    let totalCount = 0;
    const allCards = [];

    do {
      const params = new URLSearchParams({
        q: query,
        orderBy: "-set.releaseDate,number",
        page: String(page),
        pageSize: String(pageSize),
        select,
      });
      const response = await fetch(`https://api.pokemontcg.io/v2/cards?${params.toString()}`);
      if (!response.ok) throw new Error(`Pokemon TCG API ${response.status}`);
      const payload = await response.json();
      totalCount = payload.totalCount || 0;
      allCards.push(...(payload.data || []));
      page += 1;
    } while (allCards.length < totalCount);

    const cards = allCards
      .filter((card) => card.supertype === "Pokémon" && (card.nationalPokedexNumbers || []).includes(Number(dexNumber)))
      .map((card) => ({
        id: card.id,
        name: card.name,
        set: {
          name: card.set?.name || "",
          series: card.set?.series || "",
          releaseDate: card.set?.releaseDate || "",
        },
        number: card.number || "",
        rarity: card.rarity || "",
        image: card.images?.small || card.images?.large || "",
        cardmarket: card.cardmarket || null,
        marketPrice: card.cardmarket?.prices?.trendPrice || card.cardmarket?.prices?.averageSellPrice || card.cardmarket?.prices?.lowPrice || 0,
      }))
      .sort((a, b) => {
        const priceDelta = (b.marketPrice || 0) - (a.marketPrice || 0);
        if (priceDelta) return priceDelta;
        if (Boolean(b.cardmarket?.url) !== Boolean(a.cardmarket?.url)) return b.cardmarket?.url ? 1 : -1;
        return (b.set.releaseDate || "").localeCompare(a.set.releaseDate || "");
      });

    try {
      window.sessionStorage?.setItem(cacheKey, JSON.stringify(cards));
    } catch {
      // Non-critical cache write failure.
    }
    return cards;
  }

  function renderPokemonCards(list, cards, pokemonName) {
    if (!cards.length) {
      list.innerHTML = `<div class="dw-tcg-empty">Noch keine Karten gefunden.</div>`;
      return;
    }

    const exactLinks = cards.filter((card) => card.cardmarket?.url).length;
    const missingLinks = cards.length - exactLinks;
    list.innerHTML = `
      <div class="dw-tcg-summary">
        <strong>${cards.length} Karten gefunden</strong>
        <span>${exactLinks} Cardmarket-Direktlinks${missingLinks ? `, ${missingLinks} Cardmarket-Suchlinks` : ""}.</span>
      </div>
      <div class="dw-tcg-grid">
        ${cards.map((card) => {
          const href = cardmarketUrl(card);
          const searchHref = cardmarketSearchUrl(card);
          const meta = [card.set.name, card.number ? `Nr. ${card.number}` : "", card.rarity, card.set.releaseDate].filter(Boolean).join(" · ");
          return `<article class="dw-tcg-card">
            ${card.image ? `<img src="${card.image}" alt="${escapeHtml(card.name)} Karte" loading="lazy" width="92" height="128">` : ""}
            <div>
              <strong>${escapeHtml(card.name)}</strong>
              <span>${escapeHtml(meta)}</span>
              <small>${escapeHtml(cardPrice(card))}</small>
              ${href
                ? `<a href="${escapeHtml(href)}" target="_blank" rel="noopener sponsored">Cardmarket Direktlink</a>`
                : `<a href="${escapeHtml(searchHref)}" target="_blank" rel="noopener sponsored">Cardmarket Suche</a>`}
            </div>
          </article>`;
        }).join("")}
      </div>
      <a class="dw-tcg-shoplink" href="/products/toploader-sleeves-set-3x4-fur-tcg-sammelkarten">Passende Toploader fuer ${escapeHtml(pokemonName)} Karten</a>
    `;
  }

  function ensureCardmarketTool(card, dexNumber, pokemonName) {
    if (card.querySelector("[data-dw-tcg-tool]")) return;
    const tool = document.createElement("div");
    tool.className = "dw-tcg-tool";
    tool.dataset.dwTcgTool = "";
    tool.innerHTML = `
      <button type="button" class="dw-tcg-toggle" data-dw-tcg-toggle>
        Karten bei Cardmarket anzeigen
      </button>
      <div class="dw-tcg-list" data-dw-tcg-list hidden></div>
    `;
    card.appendChild(tool);

    const button = tool.querySelector("[data-dw-tcg-toggle]");
    const list = tool.querySelector("[data-dw-tcg-list]");
    button.addEventListener("click", async () => {
      const isOpen = !list.hidden;
      if (isOpen) {
        list.hidden = true;
        button.textContent = "Karten bei Cardmarket anzeigen";
        return;
      }

      list.hidden = false;
      button.textContent = "Karten ausblenden";
      if (list.dataset.loaded === "true") return;

      list.innerHTML = `<div class="dw-tcg-loading">Karten werden geladen...</div>`;
      try {
        const cards = await fetchPokemonCards(dexNumber);
        renderPokemonCards(list, cards, pokemonName);
        list.dataset.loaded = "true";
      } catch {
        list.innerHTML = `<div class="dw-tcg-empty">Karten konnten gerade nicht geladen werden.</div>`;
      }
    });
  }

  document.querySelectorAll(".dw-lex-wrap .dw-card").forEach((card) => {
    const head = card.querySelector(".dw-card-head");
    const number = card.querySelector(".dw-num")?.textContent?.match(/\d+/)?.[0];
    const name = card.querySelector(".dw-names strong")?.textContent?.trim() || "Pokemon";
    if (!head || !number) return;

    const dexNumber = Number.parseInt(number, 10);
    if (!dexNumber || Number.isNaN(dexNumber)) return;

    card.id = card.id || `pokemon-${padDexNumber(number)}`;

    if (!head.querySelector(".dw-lex-sprite")) {
      const img = document.createElement("img");
      img.className = "dw-lex-sprite";
      img.loading = "lazy";
      img.decoding = "async";
      img.alt = `${name} Sprite`;
      img.src = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${dexNumber}.png`;
      head.insertBefore(img, head.firstChild);
    }

    ensureCardmarketTool(card, dexNumber, name);
  });

  const targetHash = window.location.hash.slice(1);
  if (targetHash?.startsWith("pokemon-")) {
    window.requestAnimationFrame(() => {
      const target = document.getElementById(targetHash);
      if (!target) return;
      target.classList.add("is-dw-target");
      target.scrollIntoView({ block: "center" });
    });
  }

  function renderPokedexResults(root, query, index, loading = false) {
    const box = root.querySelector("[data-dw-pokedex-results]");
    if (!box) return;

    const q = query.trim();
    if (q.length < 2) {
      box.innerHTML = "";
      return;
    }

    const matches = index
      .map((pokemon) => ({ pokemon, score: scorePokemon(pokemon, q) }))
      .filter((item) => item.score !== null)
      .sort((a, b) => a.score - b.score || a.pokemon.number - b.pokemon.number)
      .slice(0, 8)
      .map((item) => item.pokemon);

    if (!matches.length) {
      box.innerHTML = `<div class="dw-poke-empty">${loading ? "Pokemon-Daten werden geladen..." : "Kein Pokemon gefunden. Versuche den deutschen oder englischen Namen."}</div>`;
      return;
    }

    const loadingNote = loading ? `<div class="dw-poke-empty">Weitere Pokemon werden geladen...</div>` : "";
    box.innerHTML = matches.map((pokemon) => {
      const dex = Number.parseInt(pokemon.number, 10);
      const sprite = `https://raw.githubusercontent.com/PokeAPI/sprites/master/sprites/pokemon/${dex}.png`;
      const meta = [`#${padDexNumber(dex)}`, pokemon.english, pokemon.types, `Gen ${pokemon.generation}`].filter(Boolean).join(" · ");
      return `<a class="dw-poke-result" href="${pokemon.href}">
        <img src="${sprite}" alt="${escapeHtml(pokemon.name)} Sprite" loading="lazy" width="56" height="56">
        <span><strong>${escapeHtml(pokemon.name)}</strong><span>${escapeHtml(meta)}</span></span>
        <b>Zum Pokedex</b>
      </a>`;
    }).join("") + loadingNote;
  }

  async function fetchPokedexIndex() {
    if (window.dwPokedexIndex) return window.dwPokedexIndex;
    try {
      const cached = window.sessionStorage?.getItem("dwPokedexIndex");
      if (cached) {
        window.dwPokedexIndex = JSON.parse(cached);
        return window.dwPokedexIndex;
      }
    } catch {
      // Non-critical cache read failure.
    }

    const parser = new DOMParser();
    const pages = await Promise.all(generationPages.map(async (page) => {
      const response = await fetch(page.href, { credentials: "same-origin" });
      const html = await response.text();
      return { ...page, doc: parser.parseFromString(html, "text/html") };
    }));

    const index = pages.flatMap((page) => [...page.doc.querySelectorAll(".dw-lex-wrap .dw-card")].map((card) => {
      const numberText = card.querySelector(".dw-num")?.textContent || "";
      const number = Number.parseInt(numberText.match(/\d+/)?.[0] || "", 10);
      const name = card.querySelector(".dw-names strong")?.textContent?.trim() || "";
      const english = card.querySelector(".dw-names em")?.textContent?.trim() || "";
      const types = [...card.querySelectorAll(".dw-types .dw-type")].map((node) => node.textContent.trim()).join(" · ");
      if (!number || !name) return null;
      return {
        number,
        name,
        english,
        types,
        generation: page.generation,
        href: `${page.href}#pokemon-${padDexNumber(number)}`,
      };
    }).filter(Boolean));

    window.dwPokedexIndex = index;
    try {
      window.sessionStorage?.setItem("dwPokedexIndex", JSON.stringify(index));
    } catch {
      // Non-critical cache failure.
    }
    return index;
  }

  document.querySelectorAll("[data-dw-pokedex-root]").forEach((root) => {
    if (root.dataset.dwPokedexReady === "true") return;
    root.dataset.dwPokedexReady = "true";

    const input = root.querySelector("[data-dw-pokedex-search]");
    if (!input) return;
    let requestId = 0;

    input.addEventListener("input", () => {
      const query = input.value;
      const current = requestId + 1;
      requestId = current;
      renderPokedexResults(root, query, window.dwPokedexIndex || fallbackPokemon, !window.dwPokedexIndex);
      if (query.trim().length < 2 || window.dwPokedexIndex) return;
      fetchPokedexIndex()
        .then((index) => {
          if (requestId !== current) return;
          renderPokedexResults(root, input.value, index, false);
        })
        .catch(() => {
          if (requestId !== current) return;
          renderPokedexResults(root, input.value, fallbackPokemon, false);
        });
    });

    input.addEventListener("focus", () => {
      if (!window.dwPokedexIndex) fetchPokedexIndex().catch(() => {});
    });
  });
})();
